module.exports = __webpack_public_path__ + "static/img/attribute-encryption.7798891f.png";